import { useContext, useEffect } from "react";
import { AuthContext } from "../../../../../context/context";
import { InfoTableHighRisk, SectionSelector } from "./components";
import { EndosoContext } from "pages/endoso/context";

export const AltaRiesgo12 = ({
  setMessage,
  setShowMessage,
  idSolicitud,
  spinner,
}) => {
  const { persons, setPersons } = useContext(AuthContext);
  const { showButtons } = useContext(EndosoContext);

  useEffect(() => {
    // Limpiar solo al iniciar la captura: si el componente se vuelve a montar
    // con la vista de resultados activa (re-render del padre), borrar aquí
    // dejaría vacía la tabla de asegurados ya guardados.
    if (!showButtons?.infoTable) setPersons([]);
  }, []); // eslint-disable-line
  if (!showButtons?.infoTable)
    return (
      <SectionSelector
        setMessage={setMessage}
        setShowMessage={setShowMessage}
        idSolicitud={idSolicitud}
        spinner={spinner}
      />
    );

  return <InfoTableHighRisk rows={persons} title="Asegurados Guardados" />;
};
